import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import { Box, ButtonBase, useMediaQuery, useTheme } from '@mui/material';

import { Text } from '~/components/ui/text';
import { TABLET_MIN_WIDTH } from '~/constants/common';

import BinIcon from '../../assets/bin.svg?react';
import DownloadIcon from '../../assets/download.svg?react';
import Folder from '../../assets/folder.svg?react';
import PauseIcon from '../../assets/pause.svg?react';

import * as S from './styles';

type BottomBarProps = {
  number: number;
  onDelete: () => void;
  onActivate: () => void;
  onDeactivate: () => void;
  onDownload: () => void;
  onSaveTo: () => void;
  onCancel: () => void;
};

export default function BottomBar({
  number,
  onDelete,
  onActivate,
  onDeactivate,
  onDownload,
  onSaveTo,
  onCancel,
}: BottomBarProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(TABLET_MIN_WIDTH));

  return (
    <Box sx={S.bottomBar} className={number ? 'bar-opened' : ''}>
      <Box display="flex" alignItems="center" gap="8px">
        <Text variant="t18Medium" sx={{ color: 'var(--primary)' }}>
          {number}
        </Text>
        {!isMobile && <Text variant="buttonLinedMed">{t('labels:selected')}</Text>}
      </Box>
      <Box sx={S.actionBtns}>
        {onDelete && (
          <ButtonBase sx={S.actionBtn} className="delete-btn" onClick={onDelete}>
            <BinIcon />
            {!isMobile && t('buttons:delete')}
          </ButtonBase>
        )}
        {onActivate && (
          <ButtonBase sx={S.actionBtn} onClick={onActivate}>
            <PlayArrowRoundedIcon fontSize="small" />
            {!isMobile && t('buttons:active')}
          </ButtonBase>
        )}

        {onDeactivate && (
          <ButtonBase sx={S.actionBtn} onClick={onDeactivate}>
            <PauseIcon />
            {!isMobile && t('buttons:pause')}
          </ButtonBase>
        )}

        {onDownload && (
          <ButtonBase sx={S.actionBtn} onClick={onDownload}>
            <DownloadIcon />
            {!isMobile && t('buttons:download')}
          </ButtonBase>
        )}

        {onSaveTo && (
          <ButtonBase sx={S.actionBtn} onClick={onSaveTo}>
            <Folder width="16px" height="16px" />
            {!isMobile && t('buttons:saveTo')}
          </ButtonBase>
        )}
      </Box>
      <ButtonBase sx={S.cancelBtn} onClick={onCancel}>
        {isMobile ? <CloseIcon /> : t('buttons:cancel')}
      </ButtonBase>
    </Box>
  );
}
